import { z } from 'zod';

export const RoomSettingsSchema = z.object({
  _type: z.literal('RoomsSettings'),
  defaultParty: z
    .object({
      adults: z.number(),
      children: z.number().nullable(),
    })
    .nullable(),
  checkInTime: z.string().nullable(),
  checkOutTime: z.string().nullable(),
  adultOnlyBookings: z.boolean().nullable(),
  hideCalendarPricing: z.boolean().nullable(),
  showChildAges: z.boolean(),
  childMinAge: z.number().nullable(),
  childMaxAge: z.number().nullable(),
  depositOnly: z.boolean().nullable(),
  cancellationsEnabled: z.boolean().optional().nullable(),
  multiRoomSearchEnabled: z.boolean().optional().nullable(),
});
